import Vue from 'vue'
import axios from 'axios';
import {axiosRefreshTokenSetup} from "@fixit/utils";

axiosRefreshTokenSetup(axios)


Vue.prototype.$axios = axios;
